import { Algolia } from '../../../features';

const Home = () => {
  return <Algolia isEmptyStateSearchAlgolia={'1'} stickyPositionWrapper={73} />;
};

export default Home

